import { createAction, props } from '@ngrx/store';
import { TeamUser } from '../../domains/users';

export const shareSelectionChanged = createAction(
  '[MODAL: Share With Installers] (Selection) Changed',
  props<{ selection: TeamUser['id'][] }>(),
);

export const shareSelectionCleared = createAction('[MODAL: Share With Installers] (Selection) Cleared');
